"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.schema = void 0;
var EditorTypes_1 = require("../EditorTypes");
var TokenModels_1 = __importDefault(require("ContentTokens/TokenModels"));
var Table_1 = require("ContentTokens/DataModels/Table");
var defaultBlockChildren = [EditorTypes_1.InlineType.LineBreak];
var validMarks = [EditorTypes_1.MarkType.Italic, EditorTypes_1.MarkType.Bold, EditorTypes_1.MarkType.Strikethrough, EditorTypes_1.MarkType.Comment];
exports.schema = {
    editor: {
        validChildren: [
            EditorTypes_1.BlockType.Paragraph,
            EditorTypes_1.BlockType.Heading1,
            EditorTypes_1.BlockType.Heading2,
            EditorTypes_1.BlockType.ListItem,
            EditorTypes_1.BlockType.Table,
            EditorTypes_1.BlockType.HorizontalRule,
        ],
        validFirstChild: [
            EditorTypes_1.BlockType.Paragraph,
            EditorTypes_1.BlockType.Heading1,
            EditorTypes_1.BlockType.Heading2,
            EditorTypes_1.BlockType.ListItem,
            EditorTypes_1.BlockType.HorizontalRule,
        ],
        validLastChild: [
            EditorTypes_1.BlockType.Paragraph,
            EditorTypes_1.BlockType.Heading1,
            EditorTypes_1.BlockType.Heading2,
            EditorTypes_1.BlockType.ListItem,
            EditorTypes_1.BlockType.HorizontalRule,
        ],
    },
    blocks: (_a = {},
        _a[EditorTypes_1.BlockType.Paragraph] = {
            validChildren: defaultBlockChildren,
            marks: validMarks,
        },
        _a[EditorTypes_1.BlockType.Heading1] = {
            validChildren: defaultBlockChildren,
            marks: validMarks,
        },
        _a[EditorTypes_1.BlockType.Heading2] = {
            validChildren: defaultBlockChildren,
            marks: validMarks,
        },
        _a[EditorTypes_1.BlockType.ListItem] = {
            validChildren: defaultBlockChildren,
            marks: validMarks,
        },
        _a[EditorTypes_1.BlockType.Table] = {},
        _a[EditorTypes_1.BlockType.TableCell] = {
            validChildren: [EditorTypes_1.BlockType.Paragraph, EditorTypes_1.BlockType.Heading1, EditorTypes_1.BlockType.Heading2, EditorTypes_1.BlockType.ListItem],
            createDefaultChildNode: function () { return TokenModels_1.default.paragraph.createSlateJson(""); },
            isContainerType: true,
        },
        _a[EditorTypes_1.BlockType.TableDummy] = {
            isVoid: true,
        },
        _a[EditorTypes_1.BlockType.TableRow] = {
            validChildren: [EditorTypes_1.BlockType.TableCell],
            createDefaultChildNode: function () { return (0, Table_1.createEmptyTableCellNode)(); },
            isContainerType: true,
        },
        _a),
    inlines: (_b = {},
        _b[EditorTypes_1.InlineType.LineBreak] = {
            isVoid: true,
        },
        _b),
    name: "agreement",
};
